import { IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { SEARCH, SHARE } from "../../../assets/icons";
import { CustomAvatar, SvgContainer } from "../../../components";
import theme from "../../../theme/theme";

interface Props {
  name: string;
}

function MessageDetailCard({name}: Props) {
  return (
    <Stack
      direction="row"
      alignItems={"center"}
      justifyContent={"space-between"}
      mb={2}
      sx={{backgroundColor: "#F9F9F9", p: 2}}
    >
      <Stack direction="row" alignItems={"center"}>
        <CustomAvatar
          rootStyle={{
            border: "none",
            marginTop: 0,
            marginLeft: 0,
            marginRight: 1.5,
          }}
          avatarStyle={{ borderRadius: 100, height: 48, width: 48 }}
        />
          <Typography>{name}</Typography>
      </Stack>
     <Stack direction={'row'} spacing={2}>
      <IconButton sx={{backgroundColor: "#EDEDED", width: 45, height: 45}}>
      <SvgContainer svg={SEARCH} color={theme.colors.dimgray} />
      </IconButton>
      <IconButton sx={{backgroundColor: "#EDEDED", width: 45, height: 45}}>
      <SvgContainer svg={SHARE} color={theme.colors.dimgray} />
      </IconButton>
     </Stack>
    </Stack>
  );
}

export default MessageDetailCard;
